import {createUseStyles} from 'react-jss'

export const useStyles = createUseStyles({
    '@global': {
        body: {
            backgroundColor: "#F2F5F8 !important",
            '& .page-header-fixed': {
                paddingTop:"65px"
            },
            '& #content': {
                background: "#F2F5F8 !important",
                padding: "0px 0px"
                // backgroundImage: "url(/images/blue-bk-hex.png)",
                // backgroundPosition: "100% 70%",
                // backgroundRepeat: "no-repeat",
                // backgroundSize: "100% 54%",
            },
            '& .no-gutters': {
                marginLeft: "0px !important",
                marginRight: "0px !important",
            }
        },
        [`@media screen and (max-width: 767px)`]: {
            ".page-header-fixed": {
                paddingTop: "113px !important"
            }
        },
    },
    
})